module.exports = {"id":"226414","name":"Marcus Coco","rating":"76","photo":"./data/images/photos/4/226414.png","club":{"name":"EA Guingamp","logo":"./data/images/clubs/EAGuingamp.png"},"positions":["MG","AG","MD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarcusCoco0.json
// module id = 2764
// module chunks = 0